import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { ToggleButton } from 'components';
import { useLang } from '../PlayerRegistration';
import { WAS_FOREIGN_OPTIONS } from './constants';
import './style.scss';

export const Step3 = () => {
  const { lang, t } = useLang();

  return (
    <Layout className="player-registration__step-3">
      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_3')}</Typography.Title>
        </Col>
        <Col span={24}>
          <Typography.Text>{t('description_step_3')}</Typography.Text>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col flex="1">
          <ToggleButton name="was_foreign" options={WAS_FOREIGN_OPTIONS[lang]} />
        </Col>
      </Row>
    </Layout>
  );
};
